/*
 * TerriSTORY®
 *
 © Copyright 2022 AURA-EE
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * A copy of the GNU Affero General Public License should be present along
 * with this program at the root of current repository. If not, see
 * http://www.gnu.org/licenses/.
 */

import React from "react";
import { Link } from "react-router-dom";
import config from "../../settings.js";
import { consulteAutrePage } from "../../utils.js";
import SEO from "../SEO.js";

/**
 * This component is used to manage the 'A propos' page of the application
 */
class RegionalAbout extends React.Component {
  componentDidMount() {
    let region = this.props.parentApi.data.region;
    let idUtilisateur = this.props.parentApi.data && this.props.parentApi.controller.gestionSuiviConsultations ? this.props.parentApi.controller.gestionSuiviConsultations.idUtilisateur : 0;
    let url = config.api_consultation_autre_page_url;
    consulteAutrePage(url, region, idUtilisateur, "À propos", "");
  }
  render() {
    const regionName = this.props.parentApi.data.regionLabel;
    return /*#__PURE__*/React.createElement("div", {
      className: "widgets full-screen-widget"
    }, /*#__PURE__*/React.createElement(SEO, {
      settings: this.props.parentApi.data.settings["seo"],
      page: "about"
    }), /*#__PURE__*/React.createElement(Link, {
      className: "back-to-map",
      to: "/" + this.props.parentApi.data.urlPartageable
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "close close-big",
      "data-dismiss": "alert",
      "aria-label": "Close"
    }, /*#__PURE__*/React.createElement("span", {
      "aria-hidden": "true"
    }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
      className: "tout"
    }, /*#__PURE__*/React.createElement("div", {
      className: "img"
    }, /*#__PURE__*/React.createElement("img", {
      src: "../../img/logo_TerriSTORY_region_aura_small.png",
      alt: "Logo de TerriSTORY"
    })), /*#__PURE__*/React.createElement("div", {
      className: "texte-corps"
    }, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("h1", {
      className: "title-referencement-a-propos"
    }, "Outil de pilotage de la transition \xE9cologique en", " ", regionName, " : diagnostic, strat\xE9gie et prospective territoriale"), /*#__PURE__*/React.createElement("h3", {
      className: "a-propos"
    }, "Un outil web de r\xE9f\xE9rence pour les territoires en transition"), /*#__PURE__*/React.createElement("p", null, "Outil d\u2019aide \xE0 la d\xE9cision, p\xE9dagogique et multith\xE9matique (\xE9nergie, climat, \xE9conomie...), TerriSTORY\xAE est co-construit avec les territoires. Il a \xE9t\xE9 cr\xE9\xE9 en 2018, en Auvergne-Rh\xF4ne-Alpes, \xE0 l\u2019initiative de l\u2019agence r\xE9gionale Auvergne-Rh\xF4ne-Alpes \xC9nergie Environnement (AURA-EE) et avec le soutien de la R\xE9gion Auvergne-Rh\xF4ne-Alpes et de l\u2019ADEME."), /*#__PURE__*/React.createElement("p", null, "Gr\xE2ce \xE0 une interface de visualisation dynamique et interactive, TerriSTORY\xAE permet de comprendre son territoire, d\u2019identifier ses potentiels et les leviers d\u2019actions prioritaires. Sur la base de cette analyse, l\u2019outil propose de simuler des sc\xE9narios prospectifs en mesurant leurs impacts socio-\xE9conomiques et environnementaux pour construire une trajectoire territoriale \xE0 la hauteur des enjeux."), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("h3", {
      className: "a-propos"
    }, "Une communaut\xE9 d'acteurs engag\xE9s dans un projet d'int\xE9r\xEAt g\xE9n\xE9ral"), /*#__PURE__*/React.createElement("p", null, "Depuis 2020, TerriSTORY\xAE est un projet port\xE9 par une communaut\xE9 ouverte d\u2019acteurs publics et d\u2019int\xE9r\xEAt g\xE9n\xE9ral engag\xE9s face au d\xE9fi climatique afin que les donn\xE9es soient g\xE9r\xE9es comme un bien commun. La signature d'un accord de consortium a officialis\xE9 le partenariat entre les diff\xE9rents membres du projet TerriSTORY\xAE. Cette nouvelle gouvernance apporte une r\xE9ponse concr\xE8te aux enjeux d\u2019harmonisation et d\u2019agr\xE9gation des objectifs multi-niveaux. Cela permet le d\xE9ploiement de l\u2019outil TerriSTORY\xAE dans d\u2019autres r\xE9gions et favorise la mutualisation des moyens pour le d\xE9veloppement de nouvelles fonctionnalit\xE9s et la mise \xE0 disposition de donn\xE9es compl\xE9mentaires pour chacune des r\xE9gions."), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("h3", {
      className: "a-propos"
    }, "TerriSTORY\xAE Auvergne-Rh\xF4ne-Alpes"), /*#__PURE__*/React.createElement("p", null, "Les partenaires du projet TerriSTORY\xAE en Auvergne-Rh\xF4ne-Alpes sont Atmo Auvergne-Rh\xF4ne-Alpes, AURA-EE, Enedis, GRDF, GRTgaz, l\u2019Inria, RTE, Grenoble-Alpes M\xE9tropole et Via S\xE8va. Ce projet est soutenu par la R\xE9gion Auvergne-Rh\xF4ne-Alpes, l\u2019ADEME et l\u2019Europe."), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("a", {
      href: "/pdf/auvergne-rhone-alpes/TerriSTORY_Presentation.pdf",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "Plaquette de pr\xE9sentation de TerriSTORY\xAE")), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("a", {
      href: "/pdf/auvergne-rhone-alpes/fiche_regionale_aura.pdf",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "Pr\xE9sentation de TerriSTORY\xAE Auvergne-Rh\xF4ne-Alpes")), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("a", {
      href: "/pdf/auvergne-rhone-alpes/TerriSTORY_Bilan_activite.pdf",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "Bilan d'activit\xE9 TerriSTORY\xAE")), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("a", {
      href: "https://www.youtube.com/watch?v=RHSQ_oS7XDA",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "Vid\xE9o de pr\xE9sentation de TerriSTORY\xAE"))), /*#__PURE__*/React.createElement("div", {
      className: "logos"
    }, /*#__PURE__*/React.createElement("div", {
      className: "logos-soutenus-par"
    }, /*#__PURE__*/React.createElement("p", null, "Soutenu par :"), /*#__PURE__*/React.createElement("div", {
      className: "images images-soutenu-par"
    }, /*#__PURE__*/React.createElement("img", {
      src: "/img/logo_aura.png",
      className: "logo-region",
      alt: ""
    }), /*#__PURE__*/React.createElement("img", {
      src: "/img/logo_ademe.png",
      alt: ""
    }), /*#__PURE__*/React.createElement("img", {
      src: "/img/logo_ue.png",
      alt: ""
    }))), /*#__PURE__*/React.createElement("div", {
      className: "logos-partenaires"
    }, /*#__PURE__*/React.createElement("p", null, "Partenaires :"), /*#__PURE__*/React.createElement("div", {
      className: "images-partenaires"
    }, /*#__PURE__*/React.createElement("img", {
      src: "/img/logo_atmo_aura.png",
      alt: ""
    }), /*#__PURE__*/React.createElement("img", {
      src: "/img/logo_aura_ee.png",
      alt: ""
    }), /*#__PURE__*/React.createElement("img", {
      src: "/img/logo_enedis.png",
      alt: "",
      id: "enedis"
    }), /*#__PURE__*/React.createElement("img", {
      src: "/img/grdf.png",
      alt: ""
    }), /*#__PURE__*/React.createElement("img", {
      src: "/img/grtgaz.png",
      alt: "",
      className: "petite-taille"
    }), /*#__PURE__*/React.createElement("img", {
      src: "/img/inria.png",
      alt: "",
      id: "inria"
    }), /*#__PURE__*/React.createElement("img", {
      src: "/img/rte.png",
      alt: "",
      className: "petite-taille"
    }), /*#__PURE__*/React.createElement("img", {
      src: "/img/logo_grenoble.png",
      alt: "",
      className: "petite-taille"
    }), /*#__PURE__*/React.createElement("img", {
      src: "/img/logo_viaseva.png",
      alt: "",
      className: "petite-taille"
    }))))));
  }
}
export default RegionalAbout;